import { U21Themes } from 'vendor/material-minimal/models';
import { ThemePreference } from 'app/modules/theme/models';

export const resolveTheme = (preference: ThemePreference): U21Themes => {
  if (preference === 'system') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches
      ? U21Themes.DARK
      : U21Themes.LIGHT;
  }
  return preference === 'dark' ? U21Themes.DARK : U21Themes.LIGHT;
};
